import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import '/Styling/source.scss';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
